<template>
  <div class="about-me-container">
    <!-- 背景轮播图 -->
    <div class="background-carousel">
      <transition-group name="fade">
        <div 
          v-for="(bg, index) in backgrounds" 
          :key="index" 
          class="background-slide"
          v-show="currentBgIndex === index"
          :style="{ backgroundImage: `url(${bg})` }"
        ></div>
      </transition-group>
    </div>
    
    <!-- 前景轮播图 -->
    <div class="foreground-carousel">
      <h2 style="color: white; text-align: center; margin-bottom: 20px;">About Me</h2>
      <div class="carousel-container">
        <div class="carousel-track" :style="{ transform: `translateX(-${currentSlide * 25}%)` }">
          <!-- 原始图片组 -->
          <div 
            v-for="(image, index) in images" 
            :key="index" 
            class="carousel-item"
          >
            <img :src="image.src" :alt="image.alt" @error="handleImageError">
            <div class="image-caption">{{ image.caption }}</div>
          </div>
          <!-- 复制的图片组，用于无缝循环 -->
          <div 
            v-for="(image, index) in images" 
            :key="`clone-${index}`" 
            class="carousel-item"
          >
            <img :src="image.src" :alt="image.alt" @error="handleImageError">
            <div class="image-caption">{{ image.caption }}</div>
          </div>
          <!-- 复制的图片组，用于无缝循环 -->
          <div 
            v-for="(image, index) in images" 
            :key="`clone2-${index}`" 
            class="carousel-item"
          >
            <img :src="image.src" :alt="image.alt" @error="handleImageError">
            <div class="image-caption">{{ image.caption }}</div>
          </div>
        </div>
      </div>
      
      <!-- 前景轮播控制按钮 -->
      <div class="foreground-controls">
        <button @click="prevSlide" class="control-btn prev-btn">
          <i class="fas fa-chevron-left"></i>
        </button>
        <button @click="nextSlide" class="control-btn next-btn">
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
      
      <!-- 前景轮播指示点 -->
      <!-- <div class="carousel-dots">
        <span 
          v-for="(_, index) in Math.ceil(images.length / 4)" 
          :key="index"
          :class="['dot', { active: Math.floor(currentSlide / 4) === index }]"
          @click="goToSlide(index * 4)"
        ></span>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutMe',
  data() {
    return {
      currentBgIndex: 0,
      currentSlide: 0,
      backgrounds: [
        require('../assets/images/background1.jpg'),
        require('../assets/images/background2.jpg'),
        require('../assets/images/background3.jpg')
      ],
      images: [
        { 
          src: require('../assets/images/blog1.jpg'), 
          alt: '关于我的图片1',
          caption: '2022年英语教学大赛冠军'
        },
        { 
          src: require('../assets/images/blog2.jpg'), 
          alt: '关于我的图片2',
          caption: '剑桥大学英语教育硕士'
        },
        { 
          src: require('../assets/images/blog3.jpg'), 
          alt: '关于我的图片3',
          caption: '10年英语教学经验'
        },
        { 
          src: require('../assets/images/blog4.jpg'), 
          alt: '关于我的图片4',
          caption: '雅思官方认证考官'
        },
        { 
          src: require('../assets/images/blog5.jpg'), 
          alt: '关于我的图片5',
          caption: '英语教育专业著作作者'
        },
        { 
          src: require('../assets/images/blog6.jpg'), 
          alt: '关于我的图片6',
          caption: '国际英语教育论坛演讲嘉宾'
        },
        { 
          src: require('../assets/images/blog7.jpg'), 
          alt: '关于我的图片7',
          caption: '英语教学创新奖获得者'
        },
        { 
          src: require('../assets/images/blog8.jpg'), 
          alt: '关于我的图片8',
          caption: '英语教育公益项目发起人'
        }
      ]
    }
  },
  mounted() {
    this.startBackgroundCarousel();
    this.startForegroundCarousel();
    
    // 添加鼠标悬停事件监听
    const carouselContainer = document.querySelector('.carousel-container');
    if (carouselContainer) {
      carouselContainer.addEventListener('mouseenter', this.pauseCarousel);
      carouselContainer.addEventListener('mouseleave', this.resumeCarousel);
    }
  },
  beforeDestroy() {
    if (this.bgInterval) {
      clearInterval(this.bgInterval);
    }
    if (this.fgInterval) {
      clearTimeout(this.fgInterval);
    }
    
    // 移除事件监听
    const carouselContainer = document.querySelector('.carousel-container');
    if (carouselContainer) {
      carouselContainer.removeEventListener('mouseenter', this.pauseCarousel);
      carouselContainer.removeEventListener('mouseleave', this.resumeCarousel);
    }
  },
  methods: {
    startBackgroundCarousel() {
      this.bgInterval = setInterval(() => {
        this.nextBackground();
      }, 5000);
    },
    startForegroundCarousel() {
      const slideInterval = 8000; // 保持后续间隔为8秒
      
      const autoSlide = () => {
        this.nextSlide();
        this.fgInterval = setTimeout(autoSlide, slideInterval);
      };
      
      // 2秒后开始第一次滑动
      this.fgInterval = setTimeout(() => {
        this.nextSlide();
        // 设置后续的自动滑动（8秒间隔）
        this.fgInterval = setTimeout(autoSlide, slideInterval);
      }, 2000);
    },
    
    nextSlide() {
      this.currentSlide++;
      // 当滑动到最后一张图片时，重置到第一张
      if (this.currentSlide >= this.images.length) {
        setTimeout(() => {
          // 移除过渡效果
          const track = document.querySelector('.carousel-track');
          if (track) {
            track.style.transition = 'none';
          }
          // 重置位置
          this.currentSlide = 0;
          // 重新启用过渡效果
          setTimeout(() => {
            if (track) {
              track.style.transition = 'transform 8s linear';
            }
          }, 50);
        }, 8000);
      }
    },
    
    prevSlide() {
      this.currentSlide--;
      if (this.currentSlide < 0) {
        this.currentSlide = this.images.length * 2 - 1;
      }
    },
    nextBackground() {
      this.currentBgIndex = (this.currentBgIndex + 1) % this.backgrounds.length;
    },
    prevBackground() {
      this.currentBgIndex = (this.currentBgIndex - 1 + this.backgrounds.length) % this.backgrounds.length;
    },
    goToSlide(index) {
      this.currentSlide = index;
    },
    handleImageError(e) {
      console.error('图片加载失败:', e.target.src);
      e.target.src = 'https://via.placeholder.com/300x200?text=图片加载失败';
    },
    pauseCarousel() {
      // 暂停轮播
      if (this.fgInterval) {
        clearTimeout(this.fgInterval);
        this.fgInterval = null;
      }
      
      // 暂停CSS过渡动画
      const track = document.querySelector('.carousel-track');
      if (track) {
        // 保存当前位置
        const currentTransform = getComputedStyle(track).transform;
        track.style.transition = 'none';
        track.style.transform = currentTransform;
      }
    },
    resumeCarousel() {
      // 如果已经暂停，则恢复轮播
      if (!this.fgInterval) {
        const track = document.querySelector('.carousel-track');
        if (track) {
          // 恢复过渡效果
          track.style.transition = 'transform 8s linear';
        }
        
        // 重新开始轮播
        const autoSlide = () => {
          this.nextSlide();
          this.fgInterval = setTimeout(autoSlide, 8000);
        };
        
        this.fgInterval = setTimeout(autoSlide, 2000);
      }
    }
  }
}
</script>

<style scoped>
.about-me-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
}

/* 背景轮播样式 */
.background-carousel {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
}

.background-slide {
  position: absolute;
  top: 15%;  /* 修改：距离顶部10% */
  left: 5%;  /* 修改：距离左边5% */;
  width: 90%;  /* 修改：宽度改为90%，两边各留5% */
  height: 70%;  /* 修改：高度改为80%，上下各留10% */
  background-size: cover;
  background-position: center;
  transition: opacity 1s ease;
  border-radius: 10px; /* 添加：圆角效果 */
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

/* 前景轮播样式 */
.foreground-carousel {
  position: absolute;
  top: 15%;
  left: 5%;
  width: 90%;
  height: 70%;
  z-index: 2;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 20px;
}

.carousel-container {
  width: 100%;
  height: 100%;
  overflow: hidden;
  position: relative;
}

.carousel-track {
  display: flex;
  transition: transform 8s linear;
  height: 80%;
  width: calc(100% * 2); /* 两组图片的总宽度 */
}

.carousel-item {
  flex: 0 0 12%; /* 稍微减小宽度，为间隔留出空间 */
  height: 100%;
  padding: 0 10px;
  box-sizing: border-box;
  position: relative;
  background-color: white;
  border-radius: 10px;
  display: block;
  margin-right: 10px; /* 添加右侧间隔 */
  margin-top: 15px; 
  transition: transform 0.3s ease; /* 添加过渡效果 */
}

.carousel-item:hover {
  transform: scale(1.05); /* 鼠标悬停时整个卡片放大 */
  z-index: 10; /* 确保放大时在其他卡片上方 */
}

.carousel-item img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.2);
  display: block;
  border: 2px solid white;
}

/* 移除单独的图片悬停效果，改为整个卡片悬停效果 */
.carousel-item:hover img {
  transform: none;
}

.image-caption {
  position: absolute;
  bottom: 10%;
  left: 10px;
  right: 10px;
  background-color: rgba(0, 0, 0, 0.7);
  color: white;
  padding: 10px;
  border-radius: 0 0 10px 10px;
  text-align: center;
  font-weight: bold;
}

/* 轮播控制按钮样式 */
.foreground-controls {
  position: absolute;
  top: 50%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  transform: translateY(-50%);
  z-index: 4;
  pointer-events: none;
}

.foreground-controls .control-btn {
  pointer-events: auto;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0 10px;
}

.control-btn:hover {
  background-color: rgba(0, 0, 0, 0.8);
}

/* 轮播指示点样式 */
/* .carousel-dots {
  position: absolute;
  bottom: 5%;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: rgba(255, 255, 255, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
}

.dot.active {
  background-color: white;
  transform: scale(1.2);
} */

/* 响应式设计 */
@media (max-width: 992px) {
  .carousel-item {
    flex: 0 0 calc(100% / 3); /* 中等屏幕显示3张 */
  }
}

@media (max-width: 768px) {
  .carousel-item {
    flex: 0 0 calc(100% / 2); /* 小屏幕显示2张 */
  }
}

@media (max-width: 576px) {
  .carousel-item {
    flex: 0 0 100%; /* 超小屏幕显示1张 */
  }
  
  .foreground-carousel {
    height: 60%;
  }
}
</style>